var variantSwatchGallerySectionHandlers = {};
var variantSwatchGalleryEvents = ['variant:change', 'variant:changed', 'product:variant-change'];

function registerVariantSwatchHandler(sectionId, handler) {
  if (!sectionId || typeof handler !== 'function') return;
  var previous = variantSwatchGallerySectionHandlers[sectionId];
  if (previous) {
    variantSwatchGalleryEvents.forEach(function (evt) {
      document.removeEventListener(evt, previous);
    });
  }
  variantSwatchGalleryEvents.forEach(function (evt) {
    document.addEventListener(evt, handler);
  });
  variantSwatchGallerySectionHandlers[sectionId] = handler;
}

function initVariantSwatchGallery(scope) {
  var context = scope || document;
  var root = typeof context.querySelectorAll === 'function' ? context : document;
  var swatchSelector = '.js-variant-swatch-item[data-swatch-index]';
  var swatchNodes = Array.from(root.querySelectorAll(swatchSelector));

  if (context && context !== document && typeof context.contains === 'function') {
    swatchNodes = swatchNodes.filter(function (node) {
      return context.contains(node);
    });
  }

  if (!swatchNodes.length) return;

  var swatchesBySection = new Map();

  function getSectionIdForSwatch(swatch) {
    if (!swatch) return null;
    var container = swatch.closest('.product-swatches__item');
    if (container) {
      var input = container.querySelector('input[id]');
      if (input && input.id) {
        var match = input.id.match(/(.+)-\d+-\d+$/);
        if (match && match[1]) {
          return match[1];
        }
      }
    }
    var sectionHost = swatch.closest('[data-section]');
    if (sectionHost) {
      var sectionId = sectionHost.getAttribute('data-section');
      if (sectionId) {
        return sectionId;
      }
    }
    return null;
  }

  swatchNodes.forEach(function (swatch) {
    var sectionId = getSectionIdForSwatch(swatch);
    if (!sectionId) return;
    if (!swatchesBySection.has(sectionId)) {
      swatchesBySection.set(sectionId, []);
    }
    swatchesBySection.get(sectionId).push(swatch);
  });

  swatchesBySection.forEach(function (swatches, sectionId) {
    if (!swatches.length) return;
    var wrapperSelector = '.js-product-media-wrapper[data-section="' + sectionId + '"]';
    var wrapper = null;
    if (typeof context.querySelector === 'function') {
      wrapper = context.querySelector(wrapperSelector);
    }
    if (!wrapper) {
      wrapper = document.querySelector(wrapperSelector);
    }
    if (!wrapper) return;

    var gallery = wrapper.querySelector('.js-product-slideshow');
    if (!gallery) return;
    var slides = Array.from(gallery.querySelectorAll('.js-product-slideshow-item'));
    if (!slides.length) return;
    var thumbs = Array.from(wrapper.querySelectorAll('.js-product-slideshow-thumb'));

    var swatchContainers = swatches
      .map(function (swatch) {
        return swatch.closest('.product-swatches__item');
      })
      .filter(Boolean);

    if (!swatchContainers.length) return;

    var swatchInputs = swatchContainers
      .map(function (container) {
        return container.querySelector('input[type="radio"]');
      })
      .filter(Boolean)
      .filter(function (input, index, arr) {
        return arr.indexOf(input) === index;
      });

    if (!swatchInputs.length) return;

    var variantSelector = 'sht-prd-frm[data-section="' + sectionId + '"] input[name="id"]';
    var variantInputs = [];
    if (typeof context.querySelectorAll === 'function') {
      variantInputs = Array.from(context.querySelectorAll(variantSelector));
    }
    if (!variantInputs.length) {
      variantInputs = Array.from(document.querySelectorAll(variantSelector));
    }

    function sanitizeVariantId(value) {
      if (!value) return '';
      return String(value).replace(/\s+/g, '').replace(/\D/g, '');
    }

    function getActiveVariantId() {
      for (var i = 0; i < variantInputs.length; i++) {
        var input = variantInputs[i];
        if (!input) continue;
        var val = input.value;
        if (val) {
          return String(val).trim();
        }
      }
      return null;
    }

    function getIndexFromInput(input) {
      var container = input && input.closest('.product-swatches__item');
      var relatedSwatch = container && container.querySelector('.js-variant-swatch-item[data-swatch-index]');
      return relatedSwatch ? relatedSwatch.getAttribute('data-swatch-index') : null;
    }

    function shouldShowNode(node, index, activeVariantId, numericVariantId) {
      if (!node) return false;
      var nodeIndex = node.getAttribute('data-swatch-index');
      var variantIds = (node.getAttribute('data-variant-ids') || '')
        .split(',')
        .map(function (id) {
          return id ? id.trim() : '';
        })
        .filter(Boolean);

      if (variantIds.length) {
        if (activeVariantId || numericVariantId) {
          var matchesVariant = variantIds.some(function (id) {
            if (!id) return false;
            if (activeVariantId && id === activeVariantId) return true;
            if (numericVariantId) {
              var sanitized = id.replace(/\s+/g, '').replace(/\D/g, '');
              if (sanitized && sanitized === numericVariantId) {
                return true;
              }
            }
            return false;
          });
          if (matchesVariant) {
            return true;
          }
          return false;
        }
        if (index === null || index === undefined) {
          return false;
        }
        return nodeIndex === index;
      }

      if (index === null || index === undefined) {
        return true;
      }
      return nodeIndex === index;
    }

    function showSlide(index) {
      var indexString = index != null ? String(index) : null;
      var activeVariantId = getActiveVariantId();
      var numericVariantId = sanitizeVariantId(activeVariantId);
      var hasVisibleSlide = false;

      slides.forEach(function (item) {
        if (shouldShowNode(item, indexString, activeVariantId, numericVariantId)) {
          hasVisibleSlide = true;
          item.style.display = '';
          item.classList.add('d-block');
          item.classList.remove('d-none');
          item.removeAttribute('hidden');
        } else {
          item.style.display = 'none';
          item.classList.remove('d-block');
          item.classList.add('d-none');
          item.setAttribute('hidden', 'true');
        }
      });

      if (!hasVisibleSlide && slides.length) {
        var fallbackSlide = slides[0];
        fallbackSlide.style.display = '';
        fallbackSlide.classList.add('d-block');
        fallbackSlide.classList.remove('d-none');
        fallbackSlide.removeAttribute('hidden');
      }

      var hasVisibleThumb = false;
      thumbs.forEach(function (item) {
        if (shouldShowNode(item, indexString, activeVariantId, numericVariantId)) {
          hasVisibleThumb = true;
          item.style.display = '';
          item.classList.remove('d-none');
          item.removeAttribute('hidden');
          item.classList.add('is-active-item');
        } else {
          item.style.display = 'none';
          item.classList.add('d-none');
          item.setAttribute('hidden', 'true');
          item.classList.remove('is-active-item');
        }
      });

      if (!hasVisibleThumb && thumbs.length) {
        var fallbackThumb = thumbs[0];
        fallbackThumb.style.display = '';
        fallbackThumb.classList.remove('d-none');
        fallbackThumb.removeAttribute('hidden');
        fallbackThumb.classList.add('is-active-item');
      }
    }

    function getCheckedIndex() {
      for (var i = 0; i < swatchInputs.length; i++) {
        if (swatchInputs[i] && swatchInputs[i].checked) {
          return getIndexFromInput(swatchInputs[i]);
        }
      }
      return null;
    }

    function refreshGallery() {
      var currentIndex = getCheckedIndex();
      if (currentIndex === null && swatches[0]) {
        currentIndex = swatches[0].getAttribute('data-swatch-index');
      }
      showSlide(currentIndex);
    }

    refreshGallery();

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var idx = swatch.getAttribute('data-swatch-index');
        window.setTimeout(function () {
          showSlide(idx);
        }, 0);
      });
    });

    swatchInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var idx = getIndexFromInput(input);
        window.setTimeout(function () {
          showSlide(idx);
        }, 0);
      });
    });

    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        window.setTimeout(refreshGallery, 0);
      });
    });

    registerVariantSwatchHandler(sectionId, function () {
      window.setTimeout(refreshGallery, 0);
    });
  });
}

function handleVariantMediaUpdated(event) {
  if (!event || !event.detail) return;
  var sectionId = event.detail.sectionId;
  if (!sectionId) return;
  var sectionWrapper = document.getElementById('shopify-section-' + sectionId);
  if (!sectionWrapper) {
    sectionWrapper = document.querySelector(
      '.js-product-media-wrapper[data-section="' + sectionId + '"]'
    );
  }
  if (!sectionWrapper) return;
  initVariantSwatchGallery(sectionWrapper);
}

function handleVariantSwatchInit(event) {
  initVariantSwatchGallery(event && event.target);
}

document.addEventListener('DOMContentLoaded', handleVariantSwatchInit);
document.addEventListener('shopify:section:load', handleVariantSwatchInit);
document.addEventListener('variant:media-updated', handleVariantMediaUpdated);
